import { ArrowRight } from "lucide-react";
import FooterPage from './FooterPage'

const services = [
    {
        title: "Optimized LTL Freight Management",
        description:
            "Cost-efficient transport for smaller shipments through our nationwide network, ensuring optimized routes, reduced transit costs, and reliable delivery timelines.",
        image: "/assets/services/ltl.png",
        link: "/services/ltl",
    },
    {
        title: "Powering Large-Scale Freight Movement",
        description:
            "Dedicated vehicles for large, time-sensitive consignments, offering faster transit, enhanced security, and complete control over your cargo movement.",
        image: "/assets/services/ftl.png",
        link: "/services/ftl",
    },
    {
        title: "Intelligent 3PL Supply Chain",
        description:
            "End-to-end logistics solutions including transportation, warehousing, inventory management, and order fulfillment, powered by smart technology and real-time insights.",
        image: "/assets/services/3pl.png",
        link: "/services/3pl",
    },
    {
        title: "Fast-Track Express Delivery",
        description:
            "Priority shipping solutions for urgent and high-value cargo, designed to meet tight deadlines with speed, accuracy, and real-time shipment tracking.",
        image: "/assets/services/express-delivery.png",
        link: "/services/express-delivery",
    },
    {
        title: "Connected Global Freight Network",
        description:
            "Global freight solutions with customs clearance support, end-to-end visibility, and seamless coordination across air, sea, and land transport.",
        image: "/assets/services/international-shipping.png",
        link: "/services/international",
    },
    {
        title: "Technology-Enabled Warehousing Solutions",
        description:
            "Secure, tech-enabled warehousing with complete inventory visibility, efficient space utilization, and scalable storage solutions to support your business growth.",
        image: "/assets/services/warehousing.png",
        link: "/services/warehousing",
    },
];

export default function ServicesGridSection() {
    return (
        <section className="relative bg-white mt-4">
            <div className="max-w-7xl mx-auto px-3">

                {/* Section Header */}
                <div className="max-w-3xl mx-auto mb-16 text-center">
                    {/* <h2 className="text-4xl font-extrabold text-red-600 mb-4">
                        Our{" "}
                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-red-600">
                            Services
                        </span>
                    </h2> */}

                    <h2 className="text-3xl md:text-4xl font-extrabold text-[#1B1A4B] leading-tight">
                        Our Services
                    </h2>

                    <p className="mt-3 text-[#1B1A4B] text-base">
                        To meet the dynamic market needs of your business, we deliver smart, scalable logistics that grow with you.
                    </p>
                </div>

                {/* Services Grid */}
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {services.map((service, idx) => (
                        <a
                            key={idx}
                            href={service.link}
                            className="group relative bg-white rounded-2xl border border-gray-100 
                         shadow-sm hover:shadow-xl transition-all duration-300 
                         hover:-translate-y-1 overflow-hidden"
                        >
                            {/* Image */}
                            <div className="relative h-72 overflow-hidden">
                                <img
                                    src={service.image}
                                    alt={service.title}
                                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                                />
                                {/* <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" /> */}
                            </div>

                            {/* Content */}
                            <div className="p-3">
                                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                                    <h3 className="text-lg font-bold text-[#1B1A4B]">
                                        {service.title}
                                    </h3>

                                </div>

                                <p className="mt-3 text-sm text-gray-600 leading-relaxed">
                                    {service.description}
                                </p>

                                <div className="mt-3 inline-flex items-center text-sm font-semibold text-red-600">
                                    Know More
                                    <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
                                </div>
                            </div>

                            {/* Accent Line */}
                            <span className="absolute inset-x-0 bottom-0 h-1 bg-red-600 scale-x-0 group-hover:scale-x-100 transition-transform origin-left" />
                        </a>
                    ))}
                </div>
            </div>
            <FooterPage />
        </section>
    );
}
